import { useParams } from '@tanstack/react-router';

import { MemberDetailPage } from './MemberDetailPage';

export const SupplierMemberDetailPage = () => {
    const { userId, groupId } = useParams({ from: '/_app/supplier-groups/$groupId/members/$userId' });
    return <MemberDetailPage userId={userId} groupId={groupId} />;
};
